import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../incase-domain/components/button/Button';
import {type TypedTranslation} from '../../i18n';

interface PasswordInputProps {
    onChange: (value: string) => void;
    value: string;
    name?: string;
    placeholder?: string;
    errors?: Record<string, string[]>;
}
function PasswordInput(props: PasswordInputProps): JSX.Element {
    const {onChange, value, name, placeholder, errors} = props;
    const {t} = useTranslation();

    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className={`${errors && name && (errors[name] || errors.message) && 'is-invalid'}`}>
            <div className="c-input">
                <input
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    type={showPassword ? 'text' : 'password'}
                    placeholder={placeholder || ''}
                    data-cy="password"
                />
                <Button
                    type="button"
                    square
                    size="sm"
                    variant="ghost"
                    leading={showPassword ? 'solar:eye-closed-linear' : 'solar:eye-linear'}
                    aria-label={showPassword ? t('form.hidePassword') : t('form.showPassword')}
                    aria-pressed={showPassword}
                    onClick={() => setShowPassword(!showPassword)}
                />
            </div>
            {errors && name && (
                <>
                    {errors[name]?.map((err) => (
                        <div className="c-form-help is-invalid" key={err}>
                            {t(err as TypedTranslation)}
                        </div>
                    ))}
                    <div className="c-form-help is-invalid">{t(errors.message as unknown as TypedTranslation)}</div>
                </>
            )}
        </div>
    );
}

export default PasswordInput;
